import React, { Component } from 'react';

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectProps } from "@mui/material/Select";
import { withStyles } from '@mui/styles';

import APCurrencySelectStyles from "./styles/APCurrencySelect.style";

const CURRENCY_PAIRS = ["EUR", "GBP", "USD"];

class APCurrencySelect extends Component<SelectProps, {}> {
  render() {
    return (
      <Select {...this.props} disableUnderline>
        {CURRENCY_PAIRS.map((item) => (
          <MenuItem value={item}>{item}</MenuItem>
        ))}
      </Select>
    );
  }
}

export default withStyles(APCurrencySelectStyles)(APCurrencySelect);
